import { SET_VEHICLE_VIEWS } from '../actions/types';

export default function vehicleViews(state = 0, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_VEHICLE_VIEWS: {
				return action.payload;
			}
			// no default
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/vehicleViews.js